module.exports = __webpack_public_path__ + "static/img/active3.a6474acb.png";